import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../components/Table';

export default function ContactsTable({ onSelectContact, contactId, collegeContacts }) {
  return (
    <Table className="athletics-gender-table" data-cy="contacts-list-table">
      <Table.Header className="sm-hidden-l-down">
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Title</Table.HeaderCell>
          <Table.HeaderCell>Phone</Table.HeaderCell>
          <Table.HeaderCell>Notes</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {collegeContacts
          .filter((contact) => {
            if (contactId) {
              return contact.id === contactId;
            }
            return true;
          })
          .map((contact) => (
            <Table.Row key={contact.id}>
              <Table.Cell>{contact.fullName}</Table.Cell>
              <Table.Cell>{contact.title}</Table.Cell>
              <Table.Cell>{contact.hidePhoneOnFc ? '' : contact.phone}</Table.Cell>
              <Table.Cell>{contact.notes}</Table.Cell>
              <Table.Cell>
                {contact.email ? (
                  <div
                    aria-label="Email contact"
                    role="button"
                    data-cy="select-contact"
                    className="contact-online-link"
                    onClick={() => onSelectContact(contact.id)}
                  >
                    {contactId ? 'Close' : ''} Contact
                  </div>
                ) : null}
              </Table.Cell>
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
}

ContactsTable.propTypes = {
  sendEmail: PropTypes.func,
  collegeContacts: PropTypes.array,
  contactId: PropTypes.number,
};
